import * as T from "../../utilities/frontendTypes";
import { apiGet, apiPost } from "../apiClient";

export async function createUserProfile(profile: T.NewUserProfile): Promise<T.HTTPResponse> {
  return apiPost<T.HTTPResponse>("/api/admins/create-user", profile);
}

export async function getAllAdmins(): Promise<T.AdminHeadersResponse> {
  return apiGet<T.AdminHeadersResponse>("/api/admins/partner-admins");
}

export async function createExpertProfile(newExpert: T.User): Promise<T.UpdatedProgramResponse> {
  return apiPost<T.UpdatedProgramResponse>("/api/admins/create-expert", newExpert);
}

export async function createServiceProviderProfile(newServiceProvider: T.User): Promise<T.UpdatedProgramResponse> {
  return apiPost<T.UpdatedProgramResponse>("/api/admins/create-service-provider", newServiceProvider);
}
